import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import Spacer from "../Spacer";

import Cookies from "js-cookie";

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = Cookies.get("cookie_consent");
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    Cookies.set("cookie_consent", "accepted", { expires: 365 });
    setIsVisible(false);
  };

  const handleDecline = () => {
    Cookies.set("cookie_consent", "declined", { expires: 365 });
    setIsVisible(false);
  };
  return isVisible && (
    <div style={{
      backgroundColor: '#00000050',
      position: 'fixed',
      top: '0px',
      left: '0px',
      width: '100vw',
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      zIndex: 10000
    }}>
      <div style={{
        backgroundColor: '#00263e',
        padding: '20px'
      }}>
        <div className="container">
          <p style={{ color: '#fff', marginBottom: 30 }}>Some cookies are necessary to make our site work. Select ‘Accept’ to consent to additional cookies to optimize your user experience and help us manage, monitor and improve the site; and to consent to us and our partners processing your data in line with our cookie policy, including providing personalized advertisements. Select ‘Reject’ and only necessary cookies will be used.</p>

          <div className="row" >
            <Button onClick={handleAccept} variant="contained" sx={{ background: '#6facde' }}>Accept</Button>
            <Spacer />
            <Button onClick={handleDecline} variant="contained" sx={{ background: '#6facde' }}>Reject</Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CookieBanner